import { render, staticRenderFns } from "./LoanApplicationList.vue?vue&type=template&id=5bd7ff70"
import script from "./LoanApplicationList.vue?vue&type=script&lang=js"
export * from "./LoanApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports